(() => {
  const trigger = document.querySelector('.viorra-mobile-nav__trigger');
  const drawer = document.querySelector('.viorra-mobile-nav__drawer');
  const backdrop = document.querySelector('.viorra-mobile-nav__backdrop');

  if (!trigger || !drawer || !backdrop) return;

  document.querySelector('[data-viorra-search]')?.addEventListener('click', () => {
    document.querySelector('#header-group search-button button[aria-haspopup="dialog"]')?.click();
  });

  const close = () => {
    trigger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.documentElement.classList.remove('viorra-mobile-menu-open');
    trigger.focus();
  };
  const open = () => {
    trigger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.documentElement.classList.add('viorra-mobile-menu-open');
    drawer.querySelector('a, button')?.focus();
  };

  trigger.addEventListener('click', () => (trigger.getAttribute('aria-expanded') === 'true' ? close() : open()));
  drawer.querySelectorAll('a, [data-viorra-mobile-menu-close]').forEach(element => element.addEventListener('click', close));
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', event => {
    if (trigger.getAttribute('aria-expanded') !== 'true') return;

    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = [...drawer.querySelectorAll(
      'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter(element => element.getClientRects().length > 0);

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
